export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f3122be68e3944e982cd2647c3847ef5f89008870&name=fetchTypeahead!'